import axios from '../../axios';

export type TireRightsResponse = {
  contractId: number | null;
  plateNumber?: string | null;
  tireType: string | null;
  rightType: string | null;
  rightCount: number | null;
  usedCount: number | null;
};

export default async function getTireRights(): Promise<TireRightsResponse[]> {
  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/tire/rights`);
  return res.data;
}
